<template>
  <transition name="slide">
    <div :class="{ active: isPanelOpen }" class="sidebar-panel">
      <div id="sidebar-arrow" @click.prevent="togglePanel">
      </div>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  data: () => ({
    isPanelOpen: true
  }),
  methods: {
    togglePanel() {
      this.isPanelOpen = !this.isPanelOpen;
    },
    isAdmin() {
      let roles = window.siteVar.userRoles || [];
      return roles.includes("[Admin]");
    }
  }
};
</script>

<style>
.sidebar-panel {
    overflow-y: auto;
    background-color: transparent;
    /* border-right: 1px solid #d9d9d9; */
    position: relative;
    width: 300px;
    margin-left: -250px;
    /* height: 100vh; */
    z-index: 999;
    padding: 1.5rem 1rem;
    transition: 0.3s;
    margin-top: 7%;
    margin-left: 3% !important;
}

.sidebar-panel.active {
  transition: 0.3s;
  margin-left: 0;
}

.sidebar-panel .nav-item a.active:before {
  content: "\2192";
}

#sidebar-arrow {
  position: absolute;
  right: 14px;
  top: 14px;
  cursor: pointer;
}
@media only screen and (max-width: 1040px) {
  .sidebar-panel {
     overflow-y: auto;
     background-color: transparent;
     /* border-right: 1px solid #d9d9d9; */
     position: relative;
     width: 100%;
     margin-left: -250px;
     /* height: 100vh; */
     z-index: 999;
     padding: 1.5rem 1rem;
     transition: 0.3s;
     margin-top: 7%;
     margin-left: 1% !important;
  }
}
</style>